export default { sha: '41e068c3e55e3018f8a3c5af2c2b9377a80b5344', buildNumber: 'undefined' }
